import axios from 'axios';
import { getTmsAPIURL } from '@/config.js';

export const clinicXios = axios.create({
  baseURL: getTmsAPIURL(),
});

clinicXios.interceptors.request.use((config) => {
  const token = localStorage.getItem('clinicToken');
  if (token) config.headers['x-clinic-token'] = token;
  return config;
});

export async function clinicProcess(process, options) {
  try {
    const response = await clinicXios.post('script-process', { process, options: options || {} });
    const body = response.data || {};
    if (!body.success) {
      const error = new Error((body.error && body.error.message) || 'Request failed');
      error.type = body.error && body.error.type;
      throw error;
    }
    return body.data || {};
  } catch (error) {
    const body = error.response && error.response.data;
    if (body && body.error) {
      const wrapped = new Error(body.error.message || 'Request failed');
      wrapped.type = body.error.type;
      throw wrapped;
    }
    throw error;
  }
}
